import { ReactNode } from 'react';

export enum CarouselPerPage {
  ONE = 1,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
}

export type CarouselItem = {
  id: string;
  component: ReactNode;
};

export enum CarouselVariant {
  PAGINATED = 'paginated',
  SCROLLABLE = 'scrollable',
  INFINITE = 'infinite',
}
